import { Link } from 'react-router-dom';
import { Phone, Mail, Facebook, Linkedin, Instagram } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#6B7280] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <div>
              <h3 className="text-3xl font-light tracking-[0.1em]" style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}>
                LOANS <span className="italic text-white/70">&</span> BEYOND
              </h3>
            </div>
            <p className="text-white/70 leading-relaxed">
              Your trusted Australian mortgage broker. Helping you find the perfect home loan for your needs.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors" aria-label="Facebook">
                <Facebook size={18} />
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors" aria-label="LinkedIn">
                <Linkedin size={18} />
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors" aria-label="Instagram">
                <Instagram size={18} />
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-6">Services</h4>
            <ul className="space-y-4">
              <li>
                <Link to="/services" className="text-white/70 hover:text-white transition-colors">
                  Home Loans
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/70 hover:text-white transition-colors">
                  Refinancing
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/70 hover:text-white transition-colors">
                  Investment Loans
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/70 hover:text-white transition-colors">
                  First Home Buyer
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-white/70 hover:text-white transition-colors">
                  Commercial Loans
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-4">
              <li>
                <Link to="/" className="text-white/70 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/calculator" className="text-white/70 hover:text-white transition-colors">
                  Calculator
                </Link>
              </li>
              <li>
                <Link to="/book" className="text-white/70 hover:text-white transition-colors">
                  Book Appointment
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/70 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/70 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="font-heading font-semibold text-lg mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={20} className="text-white/50 mt-1 flex-shrink-0" />
                <div className="text-white/70">
                  <p className="font-medium text-white">Jyotsna Arora</p>
                  <a href="tel:0468883356" className="hover:text-white transition-colors">0468 883 356</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={20} className="text-white/50 mt-1 flex-shrink-0" />
                <div className="text-white/70">
                  <p className="font-medium text-white">Nidhi Saini</p>
                  <a href="tel:0452510447" className="hover:text-white transition-colors">0452 510 447</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={20} className="text-white/50 mt-1 flex-shrink-0" />
                <div className="text-white/70">
                  <a href="mailto:Jyotsna@loansandbeyond.com" className="hover:text-white transition-colors block">Jyotsna@loansandbeyond.com</a>
                  <a href="mailto:Nidhi@loansandbeyond.com" className="hover:text-white transition-colors block mt-1">Nidhi@loansandbeyond.com</a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/50 text-sm">
              © {currentYear} Loans & Beyond. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <Link to="/privacy-policy" className="text-white/50 text-sm hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <span className="text-white/30">|</span>
              <p className="text-white/50 text-sm">
                ABN: 24 669 223 910
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
